import { GamoraFoundationError } from '../foundation/error/error.js';

/**
 * Not implemented
 * @type Error
 */
export class GamoraErrorLock extends GamoraFoundationError {
  constructor(message?: string) {
    super(message);
  }
}
